/**
 * Globals notification ribbon — dismiss + hide-after-visit (localStorage).
 */
const DISMISS_PREFIX = 'strider_banner_dismissed_';
const DISMISS_TTL_MS = 24 * 60 * 60 * 1000;

export class NotificationBanner {
	/**
	 * @param {HTMLElement} banner Root `.notification-banner` element.
	 */
	constructor( banner ) {
		this.banner = banner;
		this.bannerId = banner.dataset.bannerId || 'banner';
		this.hideAfterVisit = banner.dataset.hideAfterVisit === '1';
		this.storageKey = `${ DISMISS_PREFIX }${ this.bannerId }`;

		if ( this.isDismissed() ) {
			this.hide( true );
			return;
		}

		this.show();
		this.bind();
	}

	/**
	 * @return {boolean}
	 */
	isDismissed() {
		const raw = localStorage.getItem( this.storageKey );

		if ( ! raw ) {
			return false;
		}

		const dismissedAt = Number.parseInt( raw, 10 );

		if ( Number.isNaN( dismissedAt ) ) {
			localStorage.removeItem( this.storageKey );
			return false;
		}

		if ( Date.now() - dismissedAt < DISMISS_TTL_MS ) {
			return true;
		}

		localStorage.removeItem( this.storageKey );
		return false;
	}

	dismiss() {
		localStorage.setItem( this.storageKey, String( Date.now() ) );
		this.hide( true );
	}

	/**
	 * @param {boolean} updateBodyClass
	 */
	show( updateBodyClass = true ) {
		this.banner.hidden = false;

		if ( updateBodyClass ) {
			document.body.classList.add( 'has-notification-banner' );
		}

		document.dispatchEvent( new CustomEvent( 'strider:site-top-change' ) );
	}

	/**
	 * @param {boolean} updateBodyClass
	 */
	hide( updateBodyClass = true ) {
		this.banner.hidden = true;

		if ( updateBodyClass ) {
			document.body.classList.remove( 'has-notification-banner' );
		}

		document.dispatchEvent( new CustomEvent( 'strider:site-top-change' ) );
	}

	bind() {
		this.banner
			.querySelector( '[data-notification-banner-close]' )
			?.addEventListener( 'click', () => {
				this.dismiss();
			} );

		if ( this.hideAfterVisit ) {
			this.banner
				.querySelector( '[data-notification-banner-link]' )
				?.addEventListener( 'click', () => {
					this.dismiss();
				} );
		}
	}
}
